import { CollectionEntity } from "@busy-human/gearbox";
import { z } from "zod";
export var Documents;
(function (Documents) {
    Documents.BASEURL = "docs";
    Documents.VAXDOCSCHEMA = z.union([z.literal('vax-rabies'), z.literal('vax-bordetella'), z.literal('vax-dhpp'), z.literal('vax-parasite')]);
    Documents.DOCTYPESCHEMA = z.union([z.literal('contract'), z.literal('dog-pic'), ...Documents.VAXDOCSCHEMA.options]);
    function ParseName(objName) {
        const parts = objName.split('/');
        const [docs, userId, doctype, dogId, doc] = parts;
        if (docs !== Documents.BASEURL || parts.length !== 5)
            throw new Error("Filename isn't proper object");
        const doctypeparse = Documents.DOCTYPESCHEMA.safeParse(doctype);
        if (!doctypeparse.success)
            throw new Error(`Doctype ${doctype} not supported`);
        const model = {
            userId, doctype: doctypeparse.data, dogId, doc
        };
        return model;
    }
    Documents.ParseName = ParseName;
    function toRef(model) {
        return `${Documents.BASEURL}/${model.userId}/${model.doctype}/${model.dogId}/${model.doc}`;
    }
    Documents.toRef = toRef;
    class CollectionClass extends CollectionEntity {
        relationships = {};
        defaults() {
            return {
                userId: '',
                doctype: 'contract',
                dogId: '',
                doc: ''
            };
        }
    }
    Documents.CollectionClass = CollectionClass;
    Documents.Collection = new CollectionClass({ 'path': "Documents" });
})(Documents || (Documents = {}));
//# sourceMappingURL=index.js.map